import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaLocatorsModule } from '@metromarkets/sdk';

import { MmSelectComponent } from './mm-select.component';
import { MmSelectDirective } from './mm-select.directive';

@NgModule({
  declarations: [ MmSelectComponent, MmSelectDirective ],
  imports: [ CommonModule, QaLocatorsModule ],
  exports: [ MmSelectComponent ],
})
export class MmSelectModule {}
